import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var Svg24OwnedB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("path", {
        id: "24_owned_b_svg__a",
        d: "M0 0h22v22H0z"
      })
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(1 1)",
      children: [/*#__PURE__*/jsx("mask", {
        id: "24_owned_b_svg__b",
        fill: "#fff",
        children: /*#__PURE__*/jsx("use", {
          xlinkHref: "#24_owned_b_svg__a"
        })
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        d: "M10.978 22c-.374-.006-.621-.2-.776-.63-.505-1.403-1.177-2.72-2.075-3.91-1.96-2.596-4.39-4.579-7.485-5.686-.443-.157-.657-.429-.641-.804.016-.43.282-.645.663-.79 4.011-1.52 6.951-4.232 8.895-8.036.246-.482.43-.998.632-1.503.182-.453.411-.644.803-.641.38.003.619.188.783.622 1.756 4.647 5.02 7.781 9.614 9.584.41.161.615.43.609.796-.006.35-.211.612-.607.764-4.62 1.782-7.819 4.986-9.608 9.597-.175.452-.42.643-.807.637",
        mask: "url(#24_owned_b_svg__b)"
      })]
    })]
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24OwnedB$1 = Svg24OwnedB;

export { Svg24OwnedB$1 as default };
